import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';

import defaultBanner from '../../../../assets/svg/defaultBanner.svg';

interface IAdminMapTooltip {
  name: string;
  banner?: string;
  pharmacyId?: string;
}

const AdminMapTooltip: FC<IAdminMapTooltip> = ({
  name,
  banner,
  pharmacyId,
}) =>
  (
    <Box>
      {pharmacyId && (
      <img alt="banner" src={(banner || (defaultBanner as string)) ?? ''} />
      )}
      <Typography>{name}</Typography>
    </Box>
  );

export default AdminMapTooltip;
